var _rect, _rect2, _g, _ellipse, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7280_17581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7280_17581)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7280_17581",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 43.9913,
    height: 44,
    rx: 4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7280_17581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99235 42.3351C7.01477 42.3351 6.17819 41.9883 5.48263 41.2948C4.78588 40.6001 4.4375 39.7653 4.4375 38.7906V17.524C4.4375 16.5492 4.78588 15.7151 5.48263 15.0216C6.17819 14.3269 7.01477 13.9795 7.99235 13.9795H11.8459C12.9588 13.9795 14.0214 13.5159 14.7783 12.7L15.6924 11.7146C16.4493 10.8987 17.5119 10.4351 18.6249 10.4351H23.9996C25.9572 10.4351 27.5441 12.022 27.5441 13.9795V14.8578C27.5441 16.3303 28.7416 17.524 30.2141 17.524C31.6823 17.524 32.8763 18.7141 32.8763 20.1823C32.8763 21.6504 34.0665 22.8406 35.5347 22.8406H36.4312C38.3945 22.8406 39.986 24.4322 39.986 26.3955V38.7906C39.986 39.7653 39.6383 40.6001 38.9427 41.2948C38.2459 41.9883 37.4088 42.3351 36.4312 42.3351H7.99235ZM22.2118 36.1323C24.4336 36.1323 26.3224 35.3572 27.8782 33.8071C29.4329 32.2559 30.2102 30.3726 30.2102 28.1573C30.2102 25.942 29.4329 24.0587 27.8782 22.5074C26.3224 20.9573 24.4336 20.1823 22.2118 20.1823C19.99 20.1823 18.1012 20.9573 16.5453 22.5074C14.9907 24.0587 14.2133 25.942 14.2133 28.1573C14.2133 30.3726 14.9907 32.2559 16.5453 33.8071C18.1012 35.3572 19.99 36.1323 22.2118 36.1323ZM22.2118 32.5878C20.9676 32.5878 19.9159 32.1596 19.0568 31.303C18.1978 30.4464 17.7682 29.3978 17.7682 28.1573C17.7682 26.9167 18.1978 25.8682 19.0568 25.0116C19.9159 24.155 20.9676 23.7267 22.2118 23.7267C23.456 23.7267 24.5076 24.155 25.3667 25.0116C26.2258 25.8682 26.6553 26.9167 26.6553 28.1573C26.6553 29.3978 26.2258 30.4464 25.3667 31.303C24.5076 32.1596 23.456 32.5878 22.2118 32.5878ZM38.2086 17.524C37.2298 17.524 36.4312 16.7305 36.4312 15.7517C36.4312 14.773 35.6325 13.9795 34.6538 13.9795C33.675 13.9795 32.8763 13.1861 32.8763 12.2073C32.8763 11.2285 33.675 10.4351 34.6538 10.4351C35.6325 10.4351 36.4312 9.64162 36.4312 8.66285C36.4312 7.68408 37.2298 6.89062 38.2086 6.89062C39.1874 6.89062 39.986 7.68408 39.986 8.66285C39.986 9.64162 40.7847 10.4351 41.7635 10.4351C42.7422 10.4351 43.5409 11.2285 43.5409 12.2073C43.5409 13.1861 42.7422 13.9795 41.7635 13.9795C40.7847 13.9795 39.986 14.773 39.986 15.7517C39.986 16.7305 39.1874 17.524 38.2086 17.524Z",
    fill: "#233D7A"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.229,
    cy: 14.2231,
    rx: 9.77585,
    ry: 9.77778,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.2812,
    y1: 9.33594,
    x2: 35.2812,
    y2: 20.3359,
    stroke: "#FF5A5F",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.125,
    y1: 15.1641,
    x2: 41.1228,
    y2: 15.1641,
    stroke: "#FF5A5F",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.352ddff9c1cd645085c5d4337c82d9e6.svg";
export { ForwardRef as ReactComponent };